// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

/* Greif Custom Code - Start */
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    location: getLocation(state),
});

type Props = PageProps & ReturnType<typeof mapStateToProps> & HasHistory;
/* Greif Custom Code - End */

export interface HomePageStyles {
    page?: MobiusPageProps;
}

export const homePageStyles: HomePageStyles = {};
const styles = homePageStyles;

const HomePage = ({
    id,
    /* Greif Custom Code - Start */
    location,
    history,
}: Props) => {
    const { reload } = parseQueryString<{ reload?: boolean }>(location.search);

    React.useEffect(() => {
        if (reload && Boolean(reload)) {
            history.replace(location.pathname);
            window.location.reload();
        }
    }, []);
    /* Greif Custom Code - End */

    return (
        <Page data-test-selector="homePage" {...styles.page}>
            <Zone contentId={id} zoneName="Content" /> {/* Starter Removed - requireRows */}
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps)(withHistory(HomePage)), // Greif
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            {
                ...StructuredPageData,
                tooltip:
                    "Code entered in this field will be added to the head of the home page. This field only supports JSON-LD data.",
            },
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "HomePage" instead of this constant.
 */
export const HomePageContext = "HomePage";
